import React from 'react';
import PropTypes from 'prop-types';

import messageStyles from '../MessageContainer/Message/message.module.css';
import useTitle from '../../hooks/useTitle';

const PageNotFound = ({ translate }) => {
  useTitle(translate('pageNotFound'));
  return (
    <div className={`messages error ${messageStyles.messageBlock}`}>
      <div className={messageStyles.messageContent}>
        <h2 className={messageStyles.errorTitle}>{translate('pageNotFound')}</h2>
        <code>404 – {translate('pageNotFound')}</code>
      </div>
    </div>
  );
};

const { func } = PropTypes;
PageNotFound.propTypes = {
  translate: func.isRequired
};

export default PageNotFound;
